"use client";

import React from "react";
import { Facebook, Instagram, Linkedin, Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-muted animate-pulse rounded" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const socialLinks = [{
    icon: Facebook,
    href: "https://www.facebook.com/profile.php?id=61588294055628",
    label: "Facebook"
  }, {
    icon: Instagram,
    href: "https://www.instagram.com/familyfirstseniorcarellc/",
    label: "Instagram"
  }, {
    icon: Linkedin,
    href: "https://www.linkedin.com/company/family-first-senior-care-llc/",
    label: "LinkedIn"
  }];
  return <footer id="footer" className="bg-background pt-16 pb-8 border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 lg:gap-8 mb-16">
          
          {}
          <div className="md:col-span-5 lg:col-span-4 flex flex-col items-start">
            <Link to="/" className="inline-block mb-6">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586469/img/family_first_senior_care_logo.png" alt="Family First Senior Care Logo" className="h-7 w-auto" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-sm">
              A small residential assisted living home serving up to 5 residents in Silver Spring, Maryland, providing personalized senior care in a warm, family‑like atmosphere.
            </p>
          </div>

          {}
          <div className="md:col-span-3 lg:col-span-4 lg:justify-self-center">
            <h3 className="text-lg font-serif font-semibold text-primary mb-6">
              Quick Links
            </h3>
            <MenuProvider menu_id="43">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="md:col-span-4 lg:col-span-4 lg:justify-self-end">
            <h3 className="text-lg font-serif font-semibold text-primary mb-6">
              Contact Us
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-sm text-muted-foreground">
                <MapPin className="size-5 text-secondary shrink-0 mt-0.5" />
                <span>3914 Ilford Rd, Silver Spring, MD 20906, Montgomery County, Maryland</span>
              </li>
              <li className="flex items-center gap-3 text-sm text-muted-foreground">
                <Phone className="size-5 text-secondary shrink-0" />
                <Link to="tel:301-477-9779" className="hover:text-primary transition-colors">
                  301-477-9779
                </Link>
              </li>
              <li className="flex items-center gap-3 text-sm text-muted-foreground">
                <Mail className="size-5 text-secondary shrink-0" />
                <Link to="mailto:info@familyfirstassistedliving.org" className="hover:text-primary transition-colors">
                  info@familyfirstassistedliving.org
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <Separator className="mb-8" />

        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-muted-foreground">
            &copy; {currentYear} Family First Senior Care. All rights reserved.
          </p>
          
          <div className="flex items-center gap-4">
            {socialLinks.map((social, i) => {
            const Icon = social.icon;
            return <Link key={social.label} to={social.href} newTab data-index={i} className="text-muted-foreground hover:text-secondary transition-colors duration-200" aria-label={social.label}>
                  <Icon className="size-5" />
                </Link>;
          })}
          </div>
        </div>
      </div>
    </footer>;
}